import {useEffect, useState} from 'react';
import ActionModal from 'components/ActionModal';
import ButtonBigWithAction from 'elements/ButtonBigWithAction';
import DeleteRequest from 'components/DeleteRequest'
import LoadingIndicator from 'pages/LoadingIndicator';

const DeleteInvoice = ({isOpen, isOpenAction, updateStatus, updatedAction, selectedData}) => {
    const [invoice, setInvoice] = useState({invoiceNo: null, id: null})
    useEffect(() => {
        if(selectedData) {
            setInvoice({invoiceNo: selectedData.invoiceNo, id: selectedData.id})           
        } else {
            setInvoice({invoiceNo: null, id: null})
        }
    }, [selectedData])

    const [deleteStatus, setDeleteStatus] = useState(null)
    const [loading, setLoading] = useState(false)

    const handleDelete = (data) => {
        setLoading(true)
        DeleteRequest('api/invoices/'+invoice.id)
            .then(response => {
                const successMessage = (
                    <div className='text-sm text-green-100 bg-green-600 text-bold mb-2 p-1'>
                        <p>Fatura başarıyla silindi. Silinen faturalarınıza "İptal Faturalar" üzerinden ulaşabilirsiniz.</p> 
                    </div>
                )
                setDeleteStatus(successMessage)
                setLoading(false)
                updatedAction(!updateStatus)
            })
            .catch(error => {
                const err = error.response.data.errors
                if(err) {
                    const errorItems = Object.keys(err).map((value, index) => {
                        return (
                            <li key={value.toString()}>{err[value][0]}</li>
                        )
                    })
                    const errorMessage = (
                        <div className='text-sm text-red-600'>
                            <p>{error.response.data.message}</p>   
                            <ul className='list-[circle] list-inside'>
                                {errorItems}
                            </ul>                     
                        </div>
                    )

                    setDeleteStatus(errorMessage)
                } else if(error.response?.data?.ErrorStatus) {
                    if(error.response.data.ErrorStatus?.data) {
                      const errorMessage = (
                        <div className='text-sm text-gray-700 text-bold mb-2 p-1'>
                            <p>{`${error.response.data.ErrorStatus.Message}-${error.response.data.ErrorStatus.data} (${error.response.data.ErrorStatus.Code})`}</p> 
                        </div>
                      )
                      setDeleteStatus(errorMessage)
                    } else {
                      const errorMessage = (
                        <div className='text-sm text-gray-700 text-bold mb-2 p-1'>
                            <p>{`${error.response.data.ErrorStatus.Message} (${error.response.data.ErrorStatus.Code})`}</p> 
                        </div>
                      )
                      setDeleteStatus(errorMessage)
                    } 
                    
                }  else {
                  const errorMessage = (
                      <div className='text-sm text-gray-700 text-bold mb-2 p-1'>
                          <p>{`${error.response.statusText} (${error.response.status})`}</p> 
                      </div>
                  )  
                  setDeleteStatus(errorMessage)
                }             
                
                setLoading(false)
            })
    }

    const actions = (
        <>
            {!deleteStatus && <ButtonBigWithAction type="button" addClass="text-white bg-emerald-500" title="Sil" onClick={handleDelete}/>}
        </>
    )

    return (
        <ActionModal isOpen={isOpen} 
                    isOpenAction={isOpenAction} 
                    id="invoiceDeleteModal" 
                    title="Faturayı Sil" 
                    cancelButton={true} 
                    actions={actions}
                    actionsForClear={[setDeleteStatus]}>
            <div>
                {deleteStatus}
            </div>
            <div className=''>                
                {!deleteStatus && <p className='text-md text-gray-700'><span className='font-semibold underline'>{invoice.invoiceNo}</span> nolu faturayı silmek istediğinize emin misiniz?</p>}
            </div>
            {loading && <LoadingIndicator />}
        </ActionModal>
    );
};

export default DeleteInvoice;
